import React, { createContext, useContext } from 'react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { usersApi, MeResponse } from '../api/users';
import { useAuth } from './AuthContext';

interface CurrentUserContextValue {
  user: MeResponse | undefined;
  isLoading: boolean;
  refetch: UseQueryResult<MeResponse>['refetch'];
}

const CurrentUserContext = createContext<CurrentUserContextValue | null>(null);

export function CurrentUserProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['me'],
    queryFn: () => usersApi.me().then((r) => r.data),
    enabled: isAuthenticated,
  });

  return (
    <CurrentUserContext.Provider value={{ user: data, isLoading: isAuthenticated && isLoading, refetch }}>
      {children}
    </CurrentUserContext.Provider>
  );
}

export function useCurrentUser() {
  const ctx = useContext(CurrentUserContext);
  if (!ctx) throw new Error('useCurrentUser must be used within CurrentUserProvider');
  return ctx;
}
